import React, {Component} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GraficRodo2Valors from './GraficRodo2Valors';

//Cal rebre amb props: nom, participacio, resultatsFinals

class DetallParticipacio extends Component {

    
render() {   


  return (
    <Row className={"detall_participacio " + (this.props.index%2===1 ? "parell" : "senar")}>
        <Col md={2} lg={4} className="nomMunicipiLlista">{this.props.nom}</Col>
        <Col md={2} lg={2}>
            <div className="titol">Meses constituïdes</div>
            <div className="dadesPercentage">
                {((this.props.participacio.meses.mesesConstituides/this.props.participacio.meses.totalMeses)*100).toFixed(2).toString().replace(/\./g, ',')}%
            </div>
            <div className="grafic">
                <GraficRodo2Valors valor={this.props.participacio.meses.mesesConstituides} valorTotal={this.props.participacio.meses.totalMeses}/>
            </div>
            <div className="dadesAbsolutes">
                {this.props.participacio.meses.mesesConstituides.toLocaleString('en').replace(/\,/g, '.')} de {this.props.participacio.meses.totalMeses.toLocaleString('en').replace(/\,/g, '.')}
            </div>
        </Col>
        <Col md={2} lg={2}>
        <div className="titol">Avanç participació 13h</div>
             <div className="dadesPercentage">
                {this.props.participacio.participacio14.censParticipacio_per.toString().replace(/\./g, ',')}%
            </div>
            <div className="grafic">
                <GraficRodo2Valors valor={this.props.participacio.participacio14.censParticipacio_per} valorTotal={100}/>
            </div>
            <div className="dadesAbsolutes">
                {(this.props.participacio.participacio14.censParticipacio*(this.props.participacio.participacio14.censParticipacio_per/100)).toFixed(0).toLocaleString('en').replace(/\,/g, '.')} de {this.props.participacio.participacio14.censParticipacio.toLocaleString('en').replace(/\,/g, '.')} ({this.props.participacio.participacio14.numMeses}/{this.props.participacio.meses.totalMeses})
            </div>
            
        </Col>
        <Col md={2} lg={2}>
            <div className="titol">Avanç participació 18h</div>
             <div className="dadesPercentage">
                {this.props.participacio.participacio18.censParticipacio_per.toString().replace(/\./g, ',')}%
            </div>
            <div className="grafic">
                <GraficRodo2Valors valor={this.props.participacio.participacio18.censParticipacio_per} valorTotal={100}/>
            </div>
            <div className="dadesAbsolutes">
            {(this.props.participacio.participacio18.censParticipacio*(this.props.participacio.participacio18.censParticipacio_per/100)).toFixed(0).toLocaleString('en').replace(/\,/g, '.')} de {this.props.participacio.participacio18.censParticipacio.toLocaleString('en').replace(/\,/g, '.')} ({this.props.participacio.participacio18.numMeses}/{this.props.participacio.meses.totalMeses})
            </div>
        </Col>
        {this.props.resultatsFinals.censEscrutat_per>95 && //Només quan el cens escrutat és superior al 95%
        <Col md={2} lg={2}>
             <div className="titol">Participació final</div>
             <div className="dadesPercentage">
                {this.props.resultatsFinals.totalVotants_per.toString().replace(/\./g, ',')}%
            </div>
            <div className="grafic">
                <GraficRodo2Valors valor={this.props.resultatsFinals.totalVotants_per} valorTotal={100}/>
            </div>
            <div className="dadesAbsolutes">
                {this.props.resultatsFinals.totalVotants.toLocaleString('en').replace(/\,/g, '.')} de {this.props.participacio.meses.censTotal.toLocaleString('en').replace(/\,/g, '.')}
            </div>
        </Col>}
    </Row>
  );
}

}

export default DetallParticipacio; 